import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@workspace/frontend-ui";
import type { FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Arcs from "../../assets/Arcs";
import useTranslations from "../../i18n/useTranslations";

type Props = {
  id: string;
};

const FaqItem: FC<Props> = ({ id }) => {
  const {
    state: { faq },
  } = useRewardCenter();
  const t = useTranslations();
  const item = faq?.find((entry) => entry.id === id);
  if (!item) return null;

  return (
    <AccordionItem
      value={id}
      className="relative overflow-hidden rounded-2xl border-t border-t-foreground/5 bg-card p-4 shadow-md not-last:border-b-0"
    >
      <Arcs variant="card" />
      <AccordionTrigger className="items-center gap-3 py-0 font-semibold text-foreground text-sm hover:no-underline **:data-[slot=accordion-trigger-icon]:size-7 **:data-[slot=accordion-trigger-icon]:rounded-full **:data-[slot=accordion-trigger-icon]:border-t **:data-[slot=accordion-trigger-icon]:border-foreground/10 **:data-[slot=accordion-trigger-icon]:bg-foreground/10 **:data-[slot=accordion-trigger-icon]:p-1.75 **:data-[slot=accordion-trigger-icon]:text-foreground">
        {t(item.question)}
      </AccordionTrigger>
      <AccordionContent className="mt-2.5 border-t border-t-foreground/10 pt-2.5 pb-0 text-muted-foreground text-xs">
        {t(item.answer)}
      </AccordionContent>
    </AccordionItem>
  );
};

export default FaqItem;
